var React = require('react');

function QuietIconInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.93155 10.0437L13.5602 4.42174","stroke":"#0000D8","strokeWidth":"0.93901","key":0}),React.createElement("path",{"d":"M9.34341 4.03198L14.0454 4.03198L14.0454 8.57081","stroke":"#0000D8","strokeWidth":"0.93901","key":1}),React.createElement("path",{"d":"M12.6336 10.7594V13.3417H4.64249V5.36011H6.99282","stroke":"#0000D8","strokeWidth":"0.93901","key":2})]);
}

QuietIconInline.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = QuietIconInline;

QuietIconInline.default = QuietIconInline;
